// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--b474a";
export var headingContainer = "index-module--heading-container--8ea30";
export var highlight = "index-module--highlight--0044f";
export var highlightLine = "index-module--highlight-line--1613b";
export var image1 = "index-module--image-1--208e9";
export var image2 = "index-module--image-2--ab743";
export var imageContainer = "index-module--image-container--f8558";